import { createContext } from 'react'
import type { I18nStrings } from './types'

export type Lang = 'en' | 'zh'

export const I18nContext = createContext<{
  lang: Lang
  t: I18nStrings
  setLang: (lang: Lang) => void
} | null>(null)
